(function (d) {
  const menuItems = d.querySelectorAll('.sidebar .menu-item > a');
  menuItems.forEach((menuItem) => {
    const icon = d.createElement('fa-icon');
    icon.icon = 'play';
    icon.family = 'solid';
    menuItem.appendChild(icon);
  });
})(document);
